export default __webpack_public_path__ + "static/media/profilePic.9127d8b4.png";